import { render, staticRenderFns } from "./DHSchema.vue?vue&type=template&id=55e75f02&scoped=true"
import script from "./DHSchema.vue?vue&type=script&lang=js"
export * from "./DHSchema.vue?vue&type=script&lang=js"
import style0 from "./DHSchema.vue?vue&type=style&index=0&id=55e75f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e75f02",
  null
  
)

export default component.exports